/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ProfileNoteAuthorResponse } from './profileNoteAuthorResponse';
import type { ProfileNoteResponseScope } from './profileNoteResponseScope';
import type { ProfileNoteResponseSource } from './profileNoteResponseSource';
import type { ProfileNoteResponseViewerReaction } from './profileNoteResponseViewerReaction';

export interface ProfileNoteResponse {
  id: string;
  org_id: string;
  profile_id: string;
  project_id?: string | null;
  job_id?: string | null;
  parent_note_id?: string | null;
  author_user_id?: string | null;
  author?: ProfileNoteAuthorResponse | null;
  source?: ProfileNoteResponseSource;
  ats_author_name?: string | null;
  scope: ProfileNoteResponseScope;
  content: string;
  depth: number;
  like_count?: number;
  dislike_count?: number;
  viewer_reaction?: ProfileNoteResponseViewerReaction;
  created_at: string;
  updated_at: string;
  replies?: ProfileNoteResponse[];
}
